import { useClassNames } from '../../../../utils/hooks';
import { NavigationElementMore } from '../NavigationElementMore/NavigationElementMore';
import { NavigationElements } from '../NavigationElements/NavigationElements';
import { navigationBlocksStyles } from './navigationBlocks.styles';
import type { MainNavigationBlocksClassNames, MainNavigationSectionStyles, NavigationBlocksProps } from './types';

export const MainNavigationBlocks = (props: NavigationBlocksProps) => {
  const { navBlocks, setActiveNavigationKeys } = props;
  const classNames = useClassNames<MainNavigationSectionStyles, MainNavigationBlocksClassNames>(
    'NavigationBlocks',
    navigationBlocksStyles
  );

  return (
    <div className={classNames.root}>
      {navBlocks.map((block) => {
        const hasElements = Boolean(block.elements && block.elements.length > 0);
        const subTextId = block.subText ? `${block.key}-subtext` : undefined;
        // A linked block stays visible with no elements — otherwise dropping a duplicate child would
        // take its landing page out of the navigation entirely.
        if (!hasElements && !block.to) return null;

        return (
          <div key={block.key} className={classNames.block}>
            {block.to ? (
              // Rendered through NavigationElements so hover, focus and active state are identical to
              // any other nav link; `titleLink` only makes it bold. Any icon comes from `block.more`.
              <div className={classNames.titleLink}>
                <NavigationElements
                  navElements={[
                    {
                      key: `${block.key}-link`,
                      name: block.name,
                      to: block.to,
                      more: block.more,
                      dataTest: block.dataTest,
                      exact: true,
                    },
                  ]}
                  setActiveNavigationKeys={setActiveNavigationKeys}
                />
              </div>
            ) : (
              <div className={classNames.blockHeader}>
                {block.name && <div className={classNames.title}>{block.name}</div>}
                <NavigationElementMore key={block.key} more={block.more} />
              </div>
            )}

            {block.subText && (
              <div id={subTextId} className={classNames.subText}>
                {block.subText}
              </div>
            )}

            {hasElements &&
              // Grouped and labelled by the sub-text, so the relationship the colon implies visually
              // also exists programmatically instead of leaving an orphan line before the list.
              (subTextId ? (
                <div role="group" aria-labelledby={subTextId}>
                  <NavigationElements navElements={block.elements!} setActiveNavigationKeys={setActiveNavigationKeys} />
                </div>
              ) : (
                <NavigationElements navElements={block.elements!} setActiveNavigationKeys={setActiveNavigationKeys} />
              ))}
          </div>
        );
      })}
    </div>
  );
};
